import { Repository } from './repository';
import { EntityManager, Predicate, EntityQuery } from 'breeze-client';
import { Interest } from '../model/entity-model';

export class InterestRepository extends Repository<Interest> {
    constructor(manager: EntityManager) {
        super(manager, 'Interest', 'interests');
    }

    whereActive(orderBy?: string, expand?: string) {
        const predicate = this.notDeleted.and('interestCategory.deleted', '==', null);
        return this.where(predicate, orderBy, expand);
    }

    async getCategories() {
        const query = EntityQuery.from('InterestCategories')
            .where(Predicate.create('deleted', '==', null))
            .orderBy('displayOrder')
            .expand('interests');
        const result = await this.manager.executeQuery(query);
        const deletedInterests = this.manager.executeQueryLocally(EntityQuery.from('Interests').where('deleted', '!=', null));
        deletedInterests.forEach(interest => {
            interest.entityAspect.setDetached();
        });
        return result.results;
    }

    async getPeopleWithInterest(interestId: number) {
        const query = await EntityQuery.from('People')
            .where('includeInDirectory', '==', true)
            .where(new Predicate('personInterests', 'any', 'interestId', '==', interestId))
            .orderBy('lastName, firstName')
            .select('id, firstName, lastName, cellPhone, email, family.homePhone, interestsLastUpdated');
        const people = (await this.manager.executeQuery(query)).results;
        return people;
    }
}
